const getters = {
  dialogInteressado: (state) => state.dialogInteressado,
  dialogAssunto: (state) => state.dialogAssunto,
  dialogGlossario: (state) => state.dialogGlossario,

  listaTipoDocumento: (state) => state.listaTipoDocumento,
  listaUnidadesProcedencia: (state) => state.listaUnidadesProcedencia,
  listaTiposInteressado: (state) => state.listaTiposInteressado,
  listaEntidadeInteressada: (state) => state.listaEntidadeInteressada,
  listaAssunto: (state) => state.listaAssunto,
  listaAssuntoNivel1: (state) => state.listaAssuntoNivel1,
  listaItensGlossario: (state) => state.listaItensGlossario,

  tipoDocumento: (state) => state.tipoDocumento,
  unidadeProcedencia: (state) => state.unidadeProcedencia,
  tipoInteressado: (state) => state.tipoInteressado,
  interessado: (state) => state.interessado,
  assunto: (state) => state.assunto,
  resumoAssunto: (state) => state.resumoAssunto,
  urgente: (state) => state.urgente,
  motivoUrgencia: (state) => state.motivoUrgencia,
  documentoOrigem: (state) => state.documentoOrigem,
  emitente: (state) => state.emitente,
  dataDocumentoOrigem: (state) => state.dataDocumentoOrigem,
  dataRecebimentoDocumentoOrigem: (state) => state.dataRecebimentoDocumentoOrigem,
  observacao: (state) => state.observacao,

  documento: (state) => state.documento,
  buscandoDocumentoOrigem: (state) => state.buscandoDocumentoOrigem
}

export default getters
